import { render, staticRenderFns } from "./FeaturedCv.vue?vue&type=template&id=754e33d6&"
import script from "./FeaturedCv.vue?vue&type=script&lang=js&"
export * from "./FeaturedCv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports